import { Config } from './configType';

export const config: Config = {
  production: false,
  keyCloak: {
    url: 'https://senhub-dev-auth.senforce.ai',
    realm: 'alan-local-2',
    clientId: 'senhub',
    serverLoginFlow: 'jwt', // 'jwt' or 'session'

    // serverLoginFlow: {
    //   loginFlow: 'jwt', // 'jwt' or 'session'
    //   realm: 'alan-local', // 'alan-local' or 'alan-local-2'
    // },
  },
  graphql: {
    // url: 'https://senhub-dev-admin.senforce.ai/v1/graphql',
    url: 'http://localhost:8090/v1/graphql',
    // url: 'http://localhost:5003/graphql',
  },
  rest: {
    // url: 'https://senhub-dev.senforce.ai/api',
    url: 'http://localhost:5003/api',
  },
  senhubGraphql: {
    url: 'http://localhost:5003/graphql',
  },
  // keyCloak: {
  //   url: 'https://senhub-auth.senforce.ai',
  //   realm: 'senhub',
  //   clientId: 'senhub',
  // },
  // graphql: {
  //   url: 'https://senhub-admin.senforce.ai/v1/graphql',
  // },
  // rest: {
  //   url: 'https://senhub.senforce.ai/api',
  // },
  googleMap: {
    key: 'AIzaSyAE_erelWAYqPGjNuQaivhWPN2AnNx4u8M',
    mapId: '3cd26b2cdfb36b22',
  },
  apiKey: {
    hasDescription: false,
  },
  customer: {
    createS3BucketEnabled: false,
  },
};

export default config;
